import { http } from '@/utils/http';
import qs from 'qs';

const baseApiUrl = '/vote/2020project/2020dicaq/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${baseApiUrl}base-info`);
};

// 登录
const login = (data: any) => {
  return http.post(`${baseApiUrl}login`, qs.stringify(data));
};

// 获取部门列表
const getDepartments = () => {
  return http.get(`${baseApiUrl}department-list`);
};

// 获取问题列表
const getQuestionsList = () => {
  return http.get(`${baseApiUrl}answer-list`);
};

// 提交答案
const submitAnswer = (data: any) => {
  return http.post(
    `${baseApiUrl}answer-update`,
    qs.stringify(data, { encode: false }),
  );
};

export { getDepartments, getQuestionsList, submitAnswer, getBaseInfo, login };
